<template>
    <el-dialog custom-class="dialogForm" class="measDialog" :visible.sync="visible" :before-close="handleClose" :close-on-click-modal="false" width="80%" :title="title">
        <el-scrollbar class="dialogContentScroll">
            <AttendanceInfo ref="attendanceInfo" :course-code="courseCode" :class-code="classCode" :code="code"></AttendanceInfo>
        </el-scrollbar>
    </el-dialog>

</template>
<script>
import AttendanceInfo from '../../course/components/attendanceInfo.vue'
export default {
  data() {
    return {
      title: '考勤明细',
      visible: false
    }
  },
  props: {
    // 班级code
    classCode: {
      require: true,
      type: String
    },
    // 课程code
    courseCode: {
      require: true,
      type: String
    },
    code: {
      type: String
    }
  },
  components: {
    AttendanceInfo
  },
  methods: {
    handleOpen(row) {
      this.visible = true
      this.title = row.classname + row.classcoursename + row.periodname
      this.$nextTick(() => {
        this.$refs.attendanceInfo.init()
      })
    },
    handleClose() {
      this.visible = false
    }
  }
}
</script>

